// extracted by mini-css-extract-plugin
module.exports = {"menuContainer":"menu_menuContainer__1lpm6","formContainer":"menu_formContainer__3vBPM","footer":"menu_footer__Dk3ph","checkboxContainer":"menu_checkboxContainer__2oUrG"};